import { defineStore } from 'pinia'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export const useFingerprint = defineStore('fingerprint', {
  state: () => ({
    visitorId: null,
  }),
  actions: {
    async getData() {
      const fpPromise = FingerprintJS.load()

      const fp = await fpPromise
      const dt = await fp.get()

      this.visitorId = 'web.' + dt.visitorId
    },
  },
})
